import React, { useState, useEffect } from "react";
import * as Styled from "../../../CompanyForm.styled";
import * as MUIStyled from "../../../MUIStyled.js";
import {
    CloseButton,
    ButtonPurpleNext,
} from "../../elements/Buttons/Buttons.js";
import { CustomDropdownField } from "../../elements/Dropdown/Dropdown.js";
import { CustomTextField } from "../../elements/TextField/TextField";

export const TradingDialog = ({
    errors,
    open,
    onClose,
    onAddressChange,
    isTradingAddress,
    addressValues,
    title,
    tradingAddress,
    setTradingAddress,
    postalAddress,
    setPostalAddress,
    setIsTradingAddressUpdated,
    setIsPostalAddressUpdated,
    updatedGoogleAddress,
    stateOptions,
}) => {
    const [isLoading, setIsLoading] = useState(false);

    const [streetAddressErrorMsg, setStreetAddressErrorMsg] = useState("");
    const [suburbErrorMsg, setSuburbErrorMsg] = useState("");
    const [stateErrorMsg, setStateErrorMsg] = useState("");
    const [postCodeErrorMsg, setPostCodeErrorMsg] = useState("");

    const [formTradingData, setFormTradingData] = useState({
        id: 1,
        type: "trading",
        streetAddress: "",
        subPremise: "",
        suburb: "",
        state: "",
        postcode: "",
    });
    const [formPostalData, setFormPostalData] = useState({
        id: 2,
        type: "postal",
        streetAddress: "",
        subPremise: "",
        suburb: "",
        state: "",
        postcode: "",
    });

    useEffect(() => {
        if (tradingAddress && isTradingAddress) {
            setFormTradingData({
                id: 1,
                type: "trading",
                streetAddress: tradingAddress.streetAddress || "",
                subPremise: tradingAddress.subPremise || "",
                suburb: tradingAddress.suburb || "",
                state: tradingAddress.state || "",
                postcode: tradingAddress.postcode || "",
            });
        }
        if (postalAddress && !isTradingAddress) {
            setFormPostalData({
                id: 2,
                type: "postal",
                streetAddress: postalAddress.streetAddress || "",
                subPremise: postalAddress.subPremise || "",
                suburb: postalAddress.suburb || "",
                state: postalAddress.state || "",
                postcode: postalAddress.postcode || "",
            });
        }
    }, [tradingAddress, isTradingAddress, postalAddress]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        const updatedForm = {
            ...(isTradingAddress ? formTradingData : formPostalData),
            [name]: value,
        };

        if (isTradingAddress) {
            setFormTradingData(updatedForm);
        } else {
            setFormPostalData(updatedForm);
        }
    };

    const getFieldValue = (field) => {
        return isTradingAddress
            ? formTradingData[field]
            : formPostalData[field];
    };

    const handleSubmit = async (e) => {
        setIsLoading(true);
        e.preventDefault();
        let isValid = true;

        if (getFieldValue("streetAddress").trim() === "") {
            setStreetAddressErrorMsg("Street address line 1 is required");
            isValid = false;
        } else {
            setStreetAddressErrorMsg("");
        }

        if (getFieldValue("suburb").trim() === "") {
            setSuburbErrorMsg("Suburb is required");
            isValid = false;
        } else {
            setSuburbErrorMsg("");
        }

        if (getFieldValue("state").trim() === "") {
            setStateErrorMsg("State is required");
            isValid = false;
        } else {
            setStateErrorMsg("");
        }

        if (getFieldValue("postcode").trim() === "") {
            setPostCodeErrorMsg("Post code is required");
            isValid = false;
        } else {
            setPostCodeErrorMsg("");
        }

        if (!isValid) {
            setIsLoading(false);
            return;
        }

        if (isTradingAddress) {
            onAddressChange(formTradingData);
            setIsTradingAddressUpdated(true);
        } else {
            onAddressChange(formPostalData);
            setIsPostalAddressUpdated(true);
        }

        setIsLoading(false);
        onClose();
    };

    const trading = "trading";

    return (
        <Styled.WrapperDiv>
            <Styled.DialogBoxWrapper>
                <Styled.DialogBoxTitleWrapper>
                    <Styled.DialogBoxTitle>{title}</Styled.DialogBoxTitle>
                    {getFieldValue("streetAddress") === "" &&
                        getFieldValue("suburb") === "" &&
                        getFieldValue("state") === "" &&
                        getFieldValue("postcode") === "" && (
                            <CloseButton
                                onClick={onClose}
                                pageContext={trading}
                            />
                        )}
                </Styled.DialogBoxTitleWrapper>

                <div style={{ marginBottom: "30px", marginTop: "10px" }}>
                    <CustomTextField
                        fullWidth
                        label="Street Address Line 1"
                        required
                        type="text"
                        variant="outlined"
                        name="streetAddress"
                        value={getFieldValue("streetAddress")}
                        error={streetAddressErrorMsg !== ""}
                        helperText={streetAddressErrorMsg}
                        onChange={handleChange}
                        sx={{
                            "&::placeholder": {
                                fontWeight: "bold",
                                fontSize: 16,
                            },
                        }}
                    />
                </div>

                {/* Street Address Line 2 */}
                <div style={{ marginBottom: "30px", marginTop: "10px" }}>
                    <CustomTextField
                        fullWidth
                        label="Street Address Line 2"
                        type="text"
                        variant="outlined"
                        name="subPremise"
                        value={getFieldValue("subPremise")}
                        onChange={handleChange}
                        sx={{
                            "&::placeholder": {
                                fontWeight: "bold",
                                fontSize: 16,
                            },
                        }}
                    />
                </div>

                <div style={{ marginBottom: "30px" }}>
                    <CustomTextField
                        type="text"
                        fullWidth
                        required
                        label="Suburb"
                        variant="outlined"
                        name="suburb"
                        value={getFieldValue("suburb")}
                        onChange={handleChange}
                        error={suburbErrorMsg !== ""}
                        helperText={suburbErrorMsg}
                        sx={{
                            "&::placeholder": {
                                fontWeight: "bold",
                                fontSize: 16,
                            },
                        }}
                    />
                </div>

                {/* State and Post Code */}
                <Styled.OuterMainDiv>
                    <Styled.InnerDiv sx={{ width: "10%" }}>
                        <CustomDropdownField
                            required
                            value={getFieldValue("state")}
                            onChange={handleChange}
                            label="State"
                            fullWidth
                            variant="outlined"
                            name="state"
                            error={stateErrorMsg !== ""}
                            helperText={stateErrorMsg}
                            options={stateOptions}
                        />
                    </Styled.InnerDiv>

                    <Styled.InnerDiv>
                        <CustomTextField
                            fullWidth
                            required
                            label="Post Code"
                            variant="outlined"
                            name="postcode"
                            value={getFieldValue("postcode")}
                            onChange={handleChange}
                            error={postCodeErrorMsg !== ""}
                            helperText={postCodeErrorMsg}
                            sx={{
                                "&::placeholder": {
                                    fontWeight: "bold",
                                    fontSize: 16,
                                },
                            }}
                        />
                    </Styled.InnerDiv>
                </Styled.OuterMainDiv>

                <MUIStyled.CustomGrid
                    container
                    justifyContent={{ xs: "center", sm: "flex-end" }}>
                    <ButtonPurpleNext
                        type="submit"
                        onClick={handleSubmit}
                        style={{ marginTop: "20px" }}>
                        {isLoading ? (
                            <MUIStyled.CustomCircularProgress size={24} />
                        ) : (
                            "Save"
                        )}
                    </ButtonPurpleNext>
                </MUIStyled.CustomGrid>
            </Styled.DialogBoxWrapper>
        </Styled.WrapperDiv>
    );
};
